<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="addresses"
      class="mt-1"
      hide-default-footer
      :loading="loading"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.formatted_address }}</td>
          <td>{{ props.item.description }}</td>
          <td class="justify-center align-center layout">
            {{ props.item.is_primary }}
          </td>
        </tr>
      </template>
      <template v-slot:no-data>No data</template>
    </v-data-table>
  </v-card>
</template>

<script>
import fb from "@/firebase";

export default {
  name: "ProfileAddresses",
  components: {},
  props: {
    uid: String
  },
  data: () => ({
    addresses: [],
    loading: false,
    currentProfile: "",
    headers: [
      { text: "Name", value: "name", sortable: false },
      { text: "address", value: "formatted_address", sortable: false },
      { text: "Description", value: "description", sortable: false },
      {
        text: "Primary address",
        value: "is_primary",
        sortable: false,
        align: "center"
      }
    ]
  }),
  methods: {},
  mounted: function() {
    this.currentProfile = this.uid;
  },
  watch: {
    currentProfile: function(val) {
      fb.db
        .collection("stripe_customers")
        .doc(`${val}`)
        .collection("addresses")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let address = doc.data();
            address.id = doc.id;
            this.addresses.push(address);
          });
        });
    }
  }
};
</script>
